const PERM_KEY = 'cl_camera_allowed_v1';

export const getPersistedPermission = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(PERM_KEY) === 'true';
  } catch {
    return false;
  }
};

export const setPersistedPermission = (allowed: boolean): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(PERM_KEY, allowed ? 'true' : 'false');
  } catch {
    // ignore
  }
};

